<template>
    <settings-editor-base
        v-bind:label="label"
    >
        <template>
            <i class="fa fa-2x fa-undo icon" aria-hidden="true" @click="rotate(-90)" data-toggle="tooltip" v-bind:title="tooltips.settingsRotationLeftTooltip"></i>
            <i class="fa fa-2x fa-repeat icon" aria-hidden="true" @click="rotate(90)" data-toggle="tooltip" v-bind:title="tooltips.settingsRotationRightTooltip"></i>
        </template>
    </settings-editor-base>
</template>

<script>
    import {autoInitializeTooltips as autoInitializeTooltipsMixin} from "../../../../Util/Mixins/tooltips";
    import {
        settingsRotationRightTooltip,
        settingsRotationLeftTooltip
    } from "../../tooltips";
    
    import SettingsEditorBase from "./SettingsEditorBase.vue";

    export default {
        name: "settings-rotation",
        components: {SettingsEditorBase},
        mixins: [autoInitializeTooltipsMixin],
        methods: {
            rotate(degrees){
                const vm = this;
                vm.$emit('rotate', degrees);
            }
        },
        data: () => ({
            tooltips: {
                settingsRotationLeftTooltip,
                settingsRotationRightTooltip
            }
        }),
        props: {
            label: {
                type: String,
                required: true
            }
        }
    };
</script>

<style scoped>
    .icon {
        cursor: pointer;
        margin-right: 15px;
    }
</style>
